'use client';

import { LegacyRef } from 'react';
import { formatAddress } from 'utils/formatters';
import styles from 'styles/sunfire.forms.module.css';
import { ProviderLocation } from 'types/SunFire';
import AddCircleIcon from 'components/icons/AddCircleIcon';

interface ProviderModalProps {
  locations: ProviderLocation[];
  addProviderLocation: (location: ProviderLocation) => void;
  modalRef: LegacyRef<HTMLDialogElement> | undefined;
  onModalClose: () => void;
}

const ProviderModal = ({
  locations,
  addProviderLocation,
  modalRef,
  onModalClose,
}: ProviderModalProps) => {
  const handleSaveProvider = (formData: FormData) => {
    const locationId = formData.get('location') as string;

    const location = locations.find((location) => location.id === locationId);

    addProviderLocation({
      ...location,
      isPcp: formData.get('pcp') === 'on',
    } as ProviderLocation);

    onModalClose();
  };

  return (
    <dialog ref={modalRef} className={styles.modal}>
      {locations.length > 0 && (
        <div>
          <div className={styles.providerDetails}>
            <h3>Provider Details</h3>
            <p>
              <b>
                {locations[0].firstName} {locations[0].lastName}
              </b>
            </p>
            <p>{locations[0].specialties}</p>
          </div>

          <form action={handleSaveProvider} className={styles.formContainer}>
            {/* Select Providers dropdown */}
            <div className={styles.dropdownContainer}>
              <label htmlFor="location">Select provider&rsquo;s location</label>
              <select
                id="location"
                name="location"
                className={styles.dropdownSelect}
              >
                {locations.map((location) => {
                  return (
                    <option key={location.id} value={location.id}>
                      {formatAddress(location)}
                    </option>
                  );
                })}
              </select>
            </div>

            {/* PCP Checkbox */}
            <div className="checkbox-container">
              <label className="checkbox-label">
                <input type="checkbox" name="pcp" />
                <span className="checkbox"></span>
                <span>This is my primary care physician (PCP)</span>
              </label>
            </div>

            {/* Buttons container */}
            <div className={styles.modalButtonContainer}>
              <button
                className={`button ${styles.cancelBtn}`}
                type="button"
                onClick={onModalClose}
              >
                Cancel
              </button>
              <button className={`button primary ${styles.saveBtn}`}>
                <span>Save Provider</span>
                <AddCircleIcon color="white" />
              </button>
            </div>
          </form>
        </div>
      )}
    </dialog>
  );
};

export default ProviderModal;
